export const FeedPath = {
  RSS: "/rss.xml",
  ATOM: "/atom.xml",
  JSON: "/feed.json",
} as const;
export type FeedUrl = (typeof FeedPath)[keyof typeof FeedPath];

export const StaticPath = {
  FAVICON: "/favicon.ico",
  HIGH_QUALITY_ICON: "/images/favicons/icon-512x512.png",
  ICON_MASK_IMAGE: "/images/favicons/mask-icon.svg",
  HUMANS_TXT: "/humans.txt",
} as const;

export const MASK_IMAGE_COLOR = "#551A8B";

export enum Media {
  Exif = ".exif.json",
  Webp = ".webp",
  WebpSmall = ".small.webp",
  Jpeg = ".jpg",
  Webm = ".webm",
  MP4 = ".mp4",
  SVG = ".svg",
  PNG = ".png",
  MP3 = ".mp3",
}

export enum MIMEType {
  Webp = "image/webp",
  JPEG = "image/jpeg",
  PNG = "image/png",
  SVG = "image/svg+xml",
  MP3 = "audio/mpeg",
  MP4 = "video/mp4",
  Webm = "video/webm",
  Unknown = "application/octet-stream",
}

export function getURL(baseUrl: string, media: Media): string {
  return baseUrl + media;
}

const IMAGE_URL = /[^/](\.[a-z0-9]+)$/i;

// Determine based on URL whether the image is a content image or a regular image.
// We're basically just testing if it's got a "." in the last section of the URL and
// assuming that a file extension if so.
export function isImageURL(url: string): boolean {
  return IMAGE_URL.test(url);
}

export function getImageURL(url: string): string {
  return isImageURL(url) ? url : getResponsiveImageURLs(url).webp;
}

export function getMIMEType(url: string): string {
  const match = IMAGE_URL.exec(url);
  if (match) {
    const ext: string | Media = match[1];
    switch (ext as unknown) {
      case Media.Webp:
        return MIMEType.Webp;
      case Media.Jpeg:
        return MIMEType.JPEG;
      case Media.SVG:
        return MIMEType.SVG;
      case Media.PNG:
        return MIMEType.PNG;
      case Media.MP3:
        return MIMEType.MP3;
      case Media.MP4:
        return MIMEType.MP4;
      case Media.Webm:
        return MIMEType.Webm;
    }
  }
  // shouldn't be possible could throw
  return MIMEType.Unknown;
}

export function getResponsiveImageURLs(src: string) {
  return {
    webp: getURL(src, Media.Webp),
    smol: getURL(src, Media.WebpSmall),
    jpeg: getURL(src, Media.Jpeg),
  };
}
